<template>
  <b-modal
    id="new_security_question"
    title="NOVA PERGUNTA DE SEGURANÇA"
    hide-footer
    :no-close-on-backdrop="loading"
    :no-close-on-esc="loading"
    :hide-header-close="loading"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row>
        <b-col>
          <label-required-field label="Enunciado" />
          <b-input ref="autofocus" v-model="statement" />
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            :disabled="loading"
            class="v-primary ml-1"
            @click="$bvModal.hide('new_security_question')"
          >
            <i class="fa fa-arrow-left mr-1" /> VOLTAR
          </v-btn>
          <v-btn :disabled="loading" type="submit" class="v-success ml-1">
            <i class="fa fa-check mr-1" /> SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import toast from "../../../components/ToastNotification";
import api from "../../../services/api";
import ErrorsMessages from "../../components/ErrorsMessages.vue";
import LabelRequiredField from "../../components/LabelRequiredField.vue";
import WarningRequiredFields from "../../components/WarningRequiredFields.vue";
export default {
  name: "NewSecurityQuestion",
  components: { LabelRequiredField, WarningRequiredFields, ErrorsMessages },
  data() {
    return {
      errors: [],
      loading: false,

      statement: "",
    };
  },
  methods: {
    async evOnShow() {
      this.errors = [];
      this.statement = "";
    },
    async evOnShown() {
      this.$refs.autofocus.focus();
    },
    async evOnHide() {},
    async evOnSubmit() {
      this.loading = true;

      try {
        const data = { statement: this.statement };
        const response = await api.post("/default/security-question", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$emit("created");
          this.$bvModal.hide("new_security_question");
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
</style>